// src/components/Footer.js
import React from 'react';
import './Footer.css';
import logo from '../assets/Props-fondNoir-nobg.png'; // Adjust the path to your logo image

function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; {new Date().getFullYear()} PROPS Website. All rights reserved.</p>
      <img src={logo} alt="Logo" className="footer-logo" />
    </footer>
  );
}

export default Footer;
